import * as color from './color';
import * as font from './font';

export const vars = {
  color,
  font,
};
